import React from 'react'

import { Grid, Link, Typography } from '@mui/material'
import Box from '@mui/material/Box'

import RectangleButtonComponent from 'components/RectangleButton'

import { styles } from './FilterRow.styles'

export const TEST_ID = 'published-ideas-filter'

export type Props = {
	buttonOnClick: () => void
	disabled: boolean
}

export default function FilterRow(props: Props) {
	return (
		<Grid container item sx={styles.filterGrid}>
			<Box
				data-testid="published-ideas-search-input"
				sx={styles.searchBox}
			>
				{props.disabled && (
					<Typography
						data-testid={`create-custom-game-support-text`}
						sx={styles.customGamesSupportText}
					>
						Creating custom games is only available for licensed
						users. Request a{' '}
						<Link
							href={'https://go.slalom.com/brainstorm-support'}
							sx={styles.customGamesSupportLink}
						>
							license
						</Link>
						.
					</Typography>
				)}
				<RectangleButtonComponent
					data-testid="create-custom-game-button"
					color="secondary"
					text={'CREATE CUSTOM GAME'}
					onClick={props.buttonOnClick}
					disabled={props.disabled}
				/>
			</Box>
		</Grid>
	)
}
